import { Injectable } from '@angular/core';
import { MessageGridColumnsService } from './message-grid-column.service';
import { GridColumn } from '@fgpp-ui/grid';
import { ColumnTypes } from '@fgpp-ui/grid';

@Injectable()
export class MessageMatchingGridColumnService extends MessageGridColumnsService {

  get matchingTypeColumn(): GridColumn {
    return {
      'type': ColumnTypes.TEXT,
      'name': 'MATCHING_TYPE',
      'displayName': this.translateService.instant('messages.matching.matching_type'),
      'pinned': false,
       'sort': null,
      'sortable': false,
      'width': 150,
      'refinable': false,
      'facetable': false,
      'presentAsIcon': false
    };
  }
}
